import { IModelEntity } from '@pit/core';

export interface IDtoCustomerTransferTime extends IModelEntity {

    timeOfDayInMinutes?: number;

}
